import { ConfirmAlert, TextBase } from '@carboncopyco/ui';
import { useAnalytics } from '@carboncopyco/utils';
import { AnalyticsEvents } from '../../../shared/constants/analytics.events';
import { APP_MODAL_Z_INDEX } from '../../constants';
import { useRestart } from '../../hooks/useRestart';

interface RestartAppModalProps {
  onCloseModal: (isConfirmed?: boolean) => void;
}
const RestartAppModal = ({ onCloseModal }: RestartAppModalProps) => {
  const { trackEvent } = useAnalytics();
  const { restartApp } = useRestart(onCloseModal);

  const restart = () => {
    trackEvent(AnalyticsEvents.RESTART_APP, {
      location: 'desktop',
    });
    onCloseModal(true);
    restartApp();
  };

  return (
    <ConfirmAlert
      title="Restart App"
      yesLabel="Restart"
      noLabel="Cancel"
      onClose={onCloseModal}
      onConfirm={restart}
      zIndex={APP_MODAL_Z_INDEX}
      show
    >
      <div className="w-ds-normal-modal">
        <TextBase
          label="Restart app will close all open tabs. Make sure that there are no unsaved items."
          color="text-ds-natural-600"
        />
      </div>
    </ConfirmAlert>
  );
};

export default RestartAppModal;
